import script from "./Filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./Filter.vue?vue&type=script&setup=true&lang=ts"

import "./Filter.vue?vue&type=style&index=0&id=2f67d57e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f67d57e"]])

export default __exports__